import { FunctionComponent, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useEnvironment } from '../../hooks/env';
import { disableDebug, enableDebug } from './debugStorage';

const DEBUG_PARAM = 'debug';

// Watches for `?debug=true` / `?debug=false` and flips the debug flag. The
// param is removed from the URL after it's processed so it doesn't persist in
// links the user shares.
export const DebugUrlToggle: FunctionComponent = () => {
  const { environment } = useEnvironment();
  const [searchParams, setSearchParams] = useSearchParams();
  const debugParam = searchParams.get(DEBUG_PARAM);

  useEffect(() => {
    if (environment === 'production' || debugParam === null) return;
    if (debugParam === 'true') {
      enableDebug();
    } else if (debugParam === 'false') {
      disableDebug();
    }
    const next = new URLSearchParams(searchParams);
    next.delete(DEBUG_PARAM);
    setSearchParams(next, { replace: true });
  }, [debugParam, environment, searchParams, setSearchParams]);

  return null;
};
